let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6vhrJ")).then(() => parcelRequire('7t8Pn'));